var React = require('react');

function SmLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.47826 16H0V5.09091H3.47826V16ZM1.73983 3.63636C0.777739 3.63636 0 2.82109 0 1.81745C0 0.813818 0.77913 0 1.73983 0C2.69843 0 3.47826 0.815273 3.47826 1.81745C3.47826 2.82109 2.69843 3.63636 1.73983 3.63636ZM16 16H12.656V10.6909C12.656 9.42473 12.633 7.79636 10.9176 7.79636C9.17635 7.79636 8.90852 9.17527 8.90852 10.5993V16H5.56522V5.08291H8.77496V6.57455H8.82017C9.26678 5.71636 10.3583 4.81164 11.9861 4.81164C15.3739 4.81164 16 7.07273 16 10.0124V16Z"}));
}

SmLinkedinInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SmLinkedinInline;

SmLinkedinInline.default = SmLinkedinInline;
